import PhoneInput2 from './PhoneInput2';

export default PhoneInput2;
